module.exports = __webpack_public_path__ + "static/media/qr_code.659bb9c4.jpg";